import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDirectionArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 46,
	viewBox: "0 0 34 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M32.675 0.676318L0.93383 31.6179C0.691076 31.8545 0.858614 32.2664 1.19762 32.2664H19.1248C19.2234 32.2664 19.318 32.3049 19.3886 32.3737L32.675 45.3254C32.9144 45.5588 33.3167 45.3891 33.3167 45.0548V0.946926C33.3167 0.612564 32.9144 0.442923 32.675 0.676318Z",
		fill: "#A8C0FF"
	})
});
export default SvgDirectionArrow;
